<template>
  <!--拣货列表 -->
  <div class="combin-list">
    <el-form
      :inline="true"
      :model="formInline"
      label-position="left"
      class="demo-form-inline"
    >
      <el-form-item label="拣货批次：">
        <el-input
          v-model="formInline.pickCode"
          placeholder="输入拣货批次" 
          @keydown.native.enter="onSubmit"
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否拣货完成：">
        <el-select v-model="formInline.status" placeholder="全部">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option label="已完成" :value="1"></el-option>
          <el-option label="分拣中" :value="2"></el-option>
          <el-option label="拣货中" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="restSubmit">重置</el-button>
      </el-form-item>
    </el-form>
    <WmsTable
      :columns="pickColumns"
      @pageChange="pageChangeCall"
      :dataSource="dataSource" :isPagination="query" 
      isExpanded_hidden
      :hasHeader="false"
    >
      <div slot="productImg" slot-scope="{ record }">
        <ImgPreviews :images="[record.productImg]"></ImgPreviews>
      </div>
      <template #action="{ record }">
        <!-- <a @click="getDetail(record)">详情</a> -->
      </template>
      <div slot="expandedRender" slot-scope="{ record }">
        <el-table :data="record.packPkgs" :border="true">
          <el-table-column prop="productImg" label="商品图片">
            <template slot-scope="scope">
              <ImgPreviews :images="[scope.row.productImg]"></ImgPreviews>
            </template>
          </el-table-column>
          <el-table-column prop="pkgCode" label="批次号"></el-table-column>
          <el-table-column prop="gridCode" label="库位"></el-table-column>
          <el-table-column prop="useAmount" label="数量"></el-table-column>
        </el-table>
      </div>
    </WmsTable>

    <el-dialog title="组合商品详情" :visible.sync="dialogVisible">
      <detail ref="detail" @close="dialogVisible = false"></detail>
    </el-dialog>
  </div>
</template>
<script>
import WmsTable from "@/components/WmsTable";
import { combinColumns, goodsColumns, detailColumns,pickColumns} from "./combinTable";
import { Table } from "ant-design-vue";
import { packTaskPage, getCombinationListApi,pickTaskPage } from "@/apis/combination";
import ImgPreviews from "@/components/ImgPreviews";
import detail from "./combinListDetail";
export default {
  title: "拣货单",
  name: "PickList",
  components: {
    WmsTable,
    [Table.name]: Table,
    ImgPreviews,
    detail,
  },
  data() {
    return {
      combinColumns,
      goodsColumns,
      detailColumns,
      pickColumns,
      formInline: {},
      dataSource: [],
      params: {},
      query: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      dialogVisible: false,
    };
  },
  methods: {
    getList() {
      let params = {
        pageSize: this.query.pageSize,
        pageNum: this.query.current,
        ...this.formInline,
        pickType:0
      };
      pickTaskPage(params).then(({ code, data }) => {
        if (code == 0) {
          data.records.forEach((item) => {
            item.hasPicked = 0;
            if (item.packRecords) {
              item.packRecords.forEach((item_son) => {
                item.hasPicked += item_son.amount;
                item_son.printNum = ''
              });
            }
          });
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getList();},
    onSubmit() {
      this.query.current = 1
      this.getList();
    },
    restSubmit() {
      this.formInline = {}
      this.query.current = 1
      this.query.total = 0
      this.getList();
    },
    getDetail(record) {
      this.dialogVisible = true;
      this.$nextTick((_) => {
        this.$refs.detail.detail = record.packRecords;
        // this.$refs.detail.detail[0].printNum = 1;
      });
      // this.$bus.$emit("combinDetailClick");
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style lang="less" scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
